export default __webpack_public_path__ + "static/media/google.cadee8cd.png";